import styles from "./EditScreenHeaderInfoDiv.module.css";
const EditScreenHeaderInfoDiv = ({ lines, lineHeight = 0, showRed }) => {
  return (
    <>
      <div className={styles.main_div}>
        {Array.isArray(lines) &&
          lines.length > 0 &&
          lines.map((item, index) => {
            return (
              <div
                key={index}
                className={styles.text}
                style={{
                  marginBottom: index + 1 !== lines.length ? lineHeight : 0,
                  color:
                    showRed && (index === 0 || index === 1) ? "#C04A62" : "",
                }}
              >
                {item}
                {showRed && index === 1 ? (
                  <div style={{ margin: "30px 0" }}></div>
                ) : (
                  ""
                )}
              </div>
            );
          })}
      </div>
    </>
  );
};

export default EditScreenHeaderInfoDiv;
